<template>
  <div id="leaseList">
    <div v-show="!childShow">
      <table-title slot="title">筛选栏</table-title>
      <Form ref="formValidates" :model="queryParams" inline :label-width="100">
        <FormItem label="租借人：">
          <leasee-select roleType="LEASEE" v-model="queryParams.leaseeId" />
        </FormItem>
        <FormItem label="订单编号">
          <Input v-model="queryParams.orderNo" placeholder="订单编号" clearable style="width: 200px" />
        </FormItem>
        <FormItem label="状态">
          <dict-select namespace="ENUM_MID-OPERATE-LEASE" id="order.LeaseOrderStatus" :exclusion="[]" v-model="queryParams.status" />
        </FormItem>
        <FormItem label="交付方式" prop="deliveryMethod">
          <dict-select namespace="ENUM_MID-OPERATE-LEASE" id="order.DeliveryMethod" :exclusion="[]" v-model="queryParams.deliveryMethod" />
        </FormItem>
        <br />
        <FormItem label="创建时间">
          <DatePicker type="daterange" split-panels placeholder="请选择" :editable="false" @on-change="onCreateTime" style="width: 200px"></DatePicker>
        </FormItem>
        <FormItem label="预期交付时间">
          <DatePicker type="daterange" split-panels placeholder="请选择" :editable="false" @on-change="onExpectDate" style="width: 200px"></DatePicker>
        </FormItem>
        <Button type="primary" style="margin-left: 20px" @click="search">查询</Button>
      </Form>
      <!-- 租赁列表 -->
      <table-title>租赁订单列表</table-title>
      <data-grid ref="leaseList" :columns="cols" :queryParams="queryParams" paramsName="param" :queryUrl="queryUrl" subListName :dataList="[]">
        <template #default="{ columns, data }">
          <Table :columns="columns" :data="data" border stripe size="small">
            <template slot-scope="{ row }" slot="orderNo">
              <a href="javascript:;" class="hoverCollection" style="color: #2d8cf0" @click="goDetail(row)">{{ row.orderNo }}</a>
            </template>
            <template slot-scope="{ row }" slot="agreementNo">
              <a href="javascript:;" class="hoverCollection" style="color: #2d8cf0" @click="goAgreement(row.agreementNo)">{{ row.agreementNo }}</a>
            </template>
            <template slot-scope="{ row }" slot="status">
              <Tag color="gold" v-if="row.status === 'TO_CHECK'">待审核</Tag>
              <Tag color="gold" v-if="row.status === 'TO_CONFIRM'">待确认</Tag>
              <Tag color="gold" v-if="row.status === 'TO_DELIVERY'">待交付</Tag>
              <Tag color="blue" v-if="row.status === 'TERMINATE'">中止</Tag>
              <Tag color="green" v-if="row.status === 'FINISH'">完成</Tag>
              <Tag color="red" v-if="row.status === 'CANCEL'">取消</Tag>
            </template>
            <template slot-scope="{ row }" slot="operation">
              <!-- <Button type="success" size="small" v-if="row.status === 'TO_CHECK' && auditButton" @click="goDetail(row,'audit')">审核</Button>
                            <Button type="primary" size="small" v-if="row.status === 'TO_CONFIRM' && confirmButton" style="margin-left:5px" @click="affirmClick(row)">确认</Button>
                            <Button type="warning" size="small" v-if="row.status === 'TO_DELIVERY' && confirmButton" style="margin-left:5px" @click="stop(row.orderNo)">中止</Button>
                            <Button type="success" size="small" v-if="row.status === 'TO_DELIVERY' && confirmButton" style="margin-left:5px" @click="backhanderClick(row.orderNo)">交付</Button> -->
              <Button type="primary" size="small" v-show="row.status === 'TO_CHECK' && row.inputUser === userId" style="margin-left: 5px" @click="handleEdit(row.orderNo)">编辑</Button>
              <Button type="warning" size="small" style="margin-left: 5px" @click="oneMoreOrder(row)">再来一单</Button>
            </template>
          </Table>
        </template>
      </data-grid>
    </div>
    <div v-if="childShow">
      <component v-bind:is="currentChild" :paramsData="currentData" @onFinish="onFinish"></component>
    </div>
    <div>
      <editLeaseTransact v-if="isEdit" ref="editTransact" @onFinish="onFinish"></editLeaseTransact>
    </div>
  </div>
</template>
<script>
import tableTitle from "components/tableTitle/tableTitle.vue";
import dataGrid from "@/components/datagrid.vue";
import dictSelect from "@/components/select/dict-select.vue";
import leaseeSelect from "@/components/select/payee-select.vue";

import indentDetail from "./indentDetail.vue";
import leaseAffirm from "./leaseAffirm.vue";
import frameworkAgreeDetail from "./frameworkAgreeDetail.vue";
import editLeaseTransact from "../leaseTransact/editLeaseTransact.vue";

export default {
  name: "leaseList",
  components: {
    tableTitle,
    dataGrid,
    dictSelect,
    leaseeSelect, //租借人
    indentDetail, //订单详情
    leaseAffirm, //订单确认
    frameworkAgreeDetail, //框架协议
    editLeaseTransact // 编辑订单
  },
  data() {
    return {
      isEdit: false,
      userId: sessionStorage.getItem("userId"),
      childShow: false,
      confirmButton: false,
      auditButton: false,
      leaseOrderStopComment: "", //备注
      queryUrl:
        "MID-OPERATE-LEASE/messageService/orderService/queryLeaseOrders",
      queryParams: {
        orderNo: "",
        createTimeBegin: "",
        createTimeEnd: "",
        expectedDeliveryDateBegin: "",
        expectedDeliveryDateEnd: "",
        status: "",
        leaseeId: "",
        deliveryMethod: "",
        pageNum: "",
        pageSize: ""
      },
      cols: [
        { title: "订单号", slot: "orderNo" },
        {
          title: "租借人",
          key: "leaseeId",
          dict: ["bizObjects", "member", true]
        },
        {
          title: "标的物小类",
          key: "targetType",
          dict: ["target", "type", true]
        },
        { title: "框架协议号", slot: "agreementNo" },
        { title: "订单数量", key: "orderAmount" },
        { title: "确认数量", key: "operateConfirmedAmount" },
        { title: "签收数量", key: "deliveriedAmount" },
        {
          title: "所在区域",
          key: "receiveArea",
          dict: ["region", "fullArea", true]
        },
        { title: "状态", slot: "status" },
        {
          title: "预期交付时间",
          key: "expectedDeliveryDate",
          formatter: "date"
        },
        {
          title: "交付方式",
          key: "deliveryMethod",
          dict: ["ENUM_MID-OPERATE-LEASE", "order.DeliveryMethod"]
        },
        { title: "约定租期", key: "rentTerm" },
        {
          title: "是否清洗",
          key: "cleaningRequired",
          dict: ["default", "bitYesNo"]
        },
        { title: "创建时间", key: "createTime", formatter: "date" },
        { title: "操作", slot: "operation", width: 200 }
      ],
      currentChild: "",
      currentData: ""
    };
  },
  mounted() {
    this.getButton();
    this.queryParams.leaseeId = sessionStorage.getItem("memberId");
  },
  methods: {
    getButton() {
      JSON.parse(sessionStorage.getItem("menuList")).map(item => {
        if (item === "confirmButton") {
          this.confirmButton = true;
        } else if (item === "auditButton") {
          this.auditButton = true;
        }
      });
    },
    // 订单编辑
    handleEdit(id) {
      this.isEdit = true;
      this.$nextTick(() => {
        this.$refs.editTransact.init(id);
      });
    },
    // 再来一单
    oneMoreOrder(row) {
      this.$router.push({
        path: "/user-center/lease/leaseTransact",
        query: { data: JSON.stringify(row) }
      });
    },
    //   订单确认
    affirmClick(row) {
      this.childShow = true;
      this.currentChild = leaseAffirm;
      this.currentData = row;
    },
    // 子组件返回后刷新
    onFinish() {
      this.search();
      this.childShow = false;
    },
    //追加交付计划
    backhanderClick(orderNo) {
      this.$router.push({
        path: "/home/lease/backhanderLease",
        query: { orderNo }
      });
    },
    // 预期交付时间
    onExpectDate(val) {
      this.queryParams.expectedDeliveryDateBegin = val[0];
      this.queryParams.expectedDeliveryDateEnd = val[1];
    },
    // 创建时间
    onCreateTime(val) {
      (this.queryParams.createTimeBegin = val[0]),
        (this.queryParams.createTimeEnd = val[1]);
    },
    search() {
      this.$refs["leaseList"].loadFirstPage();
    },
    // 追加成功后重新请求
    backhanderSearch(params) {
      this.search();
      this.backhander.tableShow = params;
    },
    // 关闭弹框tableShow=false
    onCancel(params) {
      this.backhander.tableShow = params;
    },
    stop(orderNo) {
      let data = {
        url: "MID-OPERATE-LEASE/messageService/orderService/terminateOrder",
        body: { orderNo, leaseOrderStopComment: this.leaseOrderStopComment }
      };
      this.$Modal.confirm({
        title: "确定要中止吗?",
        render: h => {
          return h("Input", {
            props: {
              value: this.leaseOrderStopComment,
              autofocus: true,
              type: "textarea",
              placeholder: "备注"
            },
            on: {
              input: val => {
                this.leaseOrderStopComment = val;
              }
            }
          });
        },
        onOk: () => {
          data.body.leaseOrderStopComment = this.leaseOrderStopComment;
          this.invoke(data).then(res => {
            if (!res) {
              this.$Message.success("该订单中止成功！");
              this.$refs["leaseList"].loadFirstPage();
              this.leaseOrderStopComment = "";
            }
          });
        },
        onCancel: () => {
          this.leaseOrderStopComment = "";
        }
      });
    },
    // 详情
    goDetail(row, audit) {
      this.childShow = true;
      this.currentChild = indentDetail;
      this.currentData = row;
      this.currentData.audit = audit;
    },
    // 查看框架协议
    goAgreement(id) {
      this.childShow = true;
      this.currentChild = frameworkAgreeDetail;
      this.currentData = id;
    }
  }
};
</script>
<style lang="scss" scoped>
.hoverCollection:hover {
  text-decoration: underline;
}
</style>